import { useFindDefaultsForPlatformProduct } from '../../../../../../api-lib/src/gen/ops-portal-api';
import {
  PlatformProductForm,
  PlatformProductFormInput,
} from './PlatformProductForm';
import { LoadingSpinner } from '@b7hio/core-lib/src';
import { Typography } from '@mui/material';

interface Props {
  platform: PlatformUidName;
  bankUid: string;
  productUid: string;
  removePlatformFromSelected?: (uniqueId: string) => void;
}

export interface PlatformUidName {
  uniqueId: string;
  platformUid: string;
  platformName: string;
}

export const PlatformProductFormWrapper = ({
  platform,
  bankUid,
  productUid,
  removePlatformFromSelected,
}: Props) => {
  const { data, isLoading } = useFindDefaultsForPlatformProduct(
    platform.platformUid,
    bankUid
  );

  const generateDefaultValues = (): PlatformProductFormInput => {
    return {
      feeType: data?.feeType ?? undefined,
      productAlias: undefined,
      bondsmithFee: data?.bondsmithFee ?? 0,
      partnerFee: data?.partnerFee ?? undefined,
      minDeposit: data?.minDeposit ?? undefined,
      maxDeposit: data?.maxDeposit ?? undefined,
    };
  };

  return isLoading ? (
    <LoadingSpinner />
  ) : (
    <>
      <Typography variant="h6">{platform.platformName}</Typography>
      <PlatformProductForm
        platform={platform}
        bankUid={bankUid}
        productUid={productUid}
        defaultValues={generateDefaultValues()}
        removePlatformFromSelected={removePlatformFromSelected}
      />
    </>
  );
};
